import { useState } from "react";
import TabelaContasCorrentes from "./TabelaContasCorrentes";
import TabelaEntradas from "./TabelaEntradas";

function TabelaDfesPorEmitir({ dados }) {
  const [abaAtiva, setAbaAtiva] = useState("contasCorrentes");

  return (
    <div className="tabela-dfes">
      {/* Abas */}
      <div className="abas">
        <button
          className={abaAtiva === "contasCorrentes" ? "ativa" : ""}
          onClick={() => setAbaAtiva("contasCorrentes")}
        >
          Contas Correntes ({dados.contasCorrentes.length})
        </button>
        <button
          className={abaAtiva === "entradas" ? "ativa" : ""}
          onClick={() => setAbaAtiva("entradas")}
        >
          Entradas ({dados.entradas.length})
        </button>
      </div>

      {/* Conteúdo */}
      {abaAtiva === "contasCorrentes" && (
        <TabelaContasCorrentes dados={dados.contasCorrentes} />
      )}

      {abaAtiva === "entradas" && <TabelaEntradas dados={dados.entradas} />}
    </div>
  );
}

export default TabelaDfesPorEmitir; // ← EXPORT QUE FALTAVA!
